<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./SelectionTileV2.types.js";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let { color = undefined, imgSrc = undefined, strikeThrough = false }: Props = $props();

  const Host = useHost();

  let clientWidth = $state(0);
  let clientHeight = $state(0);
  let strikeThroughSize = $derived(
    strikeThrough ? `${Math.min(clientWidth, clientHeight)}px` : undefined,
  );

  $effect(() => {
    if (color) {
      Host.style.setProperty("--color", color);
    } else {
      Host.style.removeProperty("--color");
    }
  });

  $effect(() => {
    if (imgSrc) {
      const absoluteUrl = new URL(imgSrc, document.baseURI).href;
      Host.style.setProperty("--img-src", `url("${absoluteUrl}")`);
    } else {
      Host.style.removeProperty("--img-src");
    }
  });

  onMount(() => {
    let observer = new ResizeObserver(([entry]) => {
      const borderBoxSize = entry.borderBoxSize[0];
      clientWidth = borderBoxSize.inlineSize;
      clientHeight = borderBoxSize.blockSize;
    });
    observer.observe(Host);
    return () => observer.disconnect();
  });
</script>

<slot></slot>
<slot name="content"></slot>
{#if strikeThrough}
  <div class="strikethrough" style:--strike-through-size={strikeThroughSize}></div>
{/if}

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :global {
    /*            */
    .strikethrough {
      box-sizing: border-box;
      padding: tokens.$oc-semantic-spacing-50;
      position: absolute;

      height: var(--strike-through-size);
      width: var(--strike-through-size);

      /*                       */
      inset: 0;
      margin: auto;

      &:after {
        content: "";
        position: absolute;
        border-radius: tokens.$oc-semantic-border-radius-200;
        right: tokens.$oc-semantic-spacing-50;
        top: tokens.$oc-semantic-spacing-50;

        height: calc(1.41 * (100% - 2 * #{tokens.$oc-semantic-spacing-50}));
        background: tokens.$oc-component-selection-tile-strike-through-color;
        width: tokens.$oc-component-selection-tile-strike-through-width;
        outline: tokens.$oc-component-selection-tile-strike-through-outline-color solid
          tokens.$oc-component-selection-tile-strike-through-outline-width;

        transform-origin: top left;
        transform: rotate(45deg);
      }
    }
  }
</style>
